// removed by extract-text-webpack-plugin
module.exports = {"svg":"G788cd4"};